/* 
Mono
console.log('⏳ evaluating', import.meta.url);
*/

// Import project modules
import { qS, isAdmin } from './_default.js';
import { activity } from './activity.js';

const notification = {
  STAY_FOR_MS: 6000,
  active: false,
  translate: function(key, fallback){
    if(typeof window !== 'undefined' && typeof window.t === 'function'){
      return window.t(key);
    }
    return fallback;
  },
  init: async function() {
    // Activate
    notification.active = true;

    // notification
    qS('body').insertAdjacentHTML('beforeend', '<div id="notification_container" class="notification-container"></div>');

    // Info
    // Add as first child to body
    qS('body').insertAdjacentHTML('beforebegin', '<div id="info_container" class="info-container"></div>');

    // Check for URL parameters
    notification.checkForURLParamater();
  },

  showSuccess: function(message){
    if(!message){
      message = 'Saved';
    }
    notification.easterEgg();

    return notification.show(message, 'success', '#notification_container');
  },

  showLoading: function(message){
    return notification.show(message, 'loading', '#notification_container', true);
  },

  showInfo: function(message){
    return notification.show(message, 'info', '#notification_container');
  },

  showError: function(message, metadata = null){
    if(!message){
      message = 'Unknown error';
    }

    // Stringify message if object
    if(typeof message === 'object'){
      message = JSON.stringify(message);
    }

    // Log error as activity
    activity.log(activity.activityTypes.errorSeen, metadata ? { ...metadata, error: message } : message);

    // Show error notification
    return notification.show(message, 'error', '#notification_container', true);
  },

  remove: function(element){
    // Element could have been removed before
    try {
      if(element.parentElement.innerHTML === ''){
        element.parentElement.style.display = 'none';
      }
      element.remove();
    } catch (error) {
      console.log('Element no longer exists');
    }
  },

  show: function(message, type, target, stay, action = null) { 
    if(!notification.active){return;}

    const targetElement = qS(target || '#notification_container');

    if(!targetElement){
      console.log('Target element not found');
      return;
    }

    const div = document.createElement('div');
    div.classList.add(`notification`);
    if(type){
      div.classList.add(`info-${type}`);
    }

    if(stay){
      div.classList.add(`notification-stay`);
    }

    // Create the inner text div
    const textDiv = document.createElement('div');
    textDiv.classList.add('text');
    textDiv.innerHTML = message;
    
    div.appendChild(textDiv);

    // Create the close button div
    // if(stay){
    //   const closeDiv = document.createElement('div');
    //   closeDiv.classList.add('close');
      
    //   // Add an event listener to remove the parent div when close is clicked
    //   closeDiv.addEventListener('click', () => {
    //     notification.remove(div);
    //   });
      
    //   // Append textDiv and closeDiv to the main div
    //   div.appendChild(closeDiv);
    // }
    
    targetElement.appendChild(div);
    targetElement.style.display = 'flex';

    // Add action button
    if(action){
      notification.addAction(div, action);
    }else if(stay && type !== 'loading'){
      notification.addAction(div, {
        buttonText: notification.translate('notifications.hide', 'Hide'),
        callback: function(){
          notification.remove(div);
        }
      });
    }

    if(!stay){
      setTimeout(() => {
        notification.remove(div);
      }, notification.STAY_FOR_MS);
    }

    return div;
  },

  update: function(message, div, type, hide = true, action = null){
    // Check if div is in dom
    if(!div || !div.parentElement){
      console.log('Div no longer in DOM');
      return;
    }
    div.querySelector('.text').textContent = message;
    
    // Add the new type
    div.classList.remove(`info-loading`);
    div.classList.add(`info-${type}`);

    if(action){
      notification.addAction(div, action);
    }

    if(hide){
      div.classList.remove('notification-stay');
      div.classList.add('notification-updated');
      setTimeout(() => {
        notification.remove(div);
      }, notification.STAY_FOR_MS);
    }
  },

  addAction: function(div, action){
    const buttonDiv = document.createElement('div');
    buttonDiv.classList.add('button');
    buttonDiv.textContent = action.buttonText;
    div.appendChild(buttonDiv);
    buttonDiv.addEventListener('click', function(){action.callback(); notification.remove(div);});
  },

  easterEgg: function(){
    if(!notification.active){return;}
    if(!isAdmin){return;} // Only for pages /admin
    if(Math.random() > .01){return;} // 1% chance

    const easterEggDiv = document.createElement('div');
    easterEggDiv.classList.add('easter-egg');
    document.body.appendChild(easterEggDiv);

    setTimeout(() => {
      easterEggDiv.remove();
    }, 5000);
  },

  checkForURLParamater: function(){
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const info = params.has('info') ? decodeURIComponent(params.get('info')) : null;
    if(info){
      notification.show(info, params.get(`info_type`) || null, '#info_container', true);
    }
    const notificationInUrl = params.has('notification') ? decodeURIComponent(params.get('notification')) : null;
    if(notificationInUrl){
      notification.show(notificationInUrl, params.get(`notification_type`) || null, '#notification_container');
    }

    // Remove URL parameters
    ['info', 'notification', 'info_type', 'notification_type'].forEach(param => params.delete(param));
    const newUrl = params.toString() ? `${url.pathname}?${params.toString()}` : url.pathname;
    window.history.replaceState({}, document.title, newUrl);   
  },

  clear: function(){
    qS('#notification_container').innerHTML = '';
  }
}

// For all modules available
window.notification = notification;

export { notification };
